import(/* webpackMode: "eager" */ "/Users/poojaagrawal/Projects/itellisecure/src/app/resources/page.tsx");
